import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import qs from 'qs';
import * as constants from '../util/constants';
import helpers from '../util/helpers';

const OffersSkeleton = () => {
  return (
    <Fragment>
      {
        Array.from(Array(6).keys()).map((i) => {
          return (
            <div key={i} className="col-span-1">
              <div className="offer-item skeleton">
                <div className="offer-item-image-wrapper skeleton-shine" />
                <div className="offer-item-types-wrapper">
                  <div className="offer-item-type skeleton-shine" />
                </div>
                <div className="offer-item-title skeleton-shine" />
                <div className="offer-item-description skeleton-shine" />
                <div className="offer-item-link-wrapper">
                  <div className="offer-item-link skeleton-shine" />
                </div>
              </div>
            </div>
          );
        })
      }
    </Fragment>
  );
};

class AppHotelOffers extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      offersCount: 0,
      allOffers: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.type = '';

    const type = helpers.getParameterByName('type');
    if (type != null && type.length) {
      this.type = type;
    }

    this.loadOffers = this.loadOffers.bind(this);
    this.loadMoreOffers = this.loadMoreOffers.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    // Load results on first page load
    this.loadOffers();

    $(document).on(constants.EVENT_OFFERS_TYPE_FILTER_CHANGED, (e, type) => {
      if (this.type !== type) {
        this.type = type;
        this.loadOffers();
      }
    });
  }

  loadOffers() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_HOTEL_OFFERS,
      'type': this.type,
      'featured_offer_id': this.props.featuredOfferId,
      'offset': 0,
    };

    // Send request
    axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const offersCount = response.data['offers_count'];
          const offers = response.data['offers'];

          if (offersCount > 0) {
            this.setState({
              loading: false,
              offersCount,
              allOffers: [...offers],
              loadMoreLoading: false,
              loadedAll: parseInt(offersCount) === offers.length,
            });
          } else {
            this.setState({
              loading: false,
              offersCount: 0,
              allOffers: [],
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            offersCount: 0,
            allOffers: [],
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreOffers() {
    const {
      allOffers,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_HOTEL_OFFERS,
        'type': this.type,
        'featured_offer_id': this.props.featuredOfferId,
        'offset': allOffers.length,
      };

      // Send request
      axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const offersCount = response.data['offers_count'];
            const offers = [
              ...allOffers,
              ...response.data['offers'],
            ];

            if (offersCount > 0) {
              this.setState({
                loading: false,
                allOffers: [...offers],
                loadMoreLoading: false,
                loadedAll: parseInt(offersCount) === offers.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  render() {
    const {
      loading,
      allOffers,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <Fragment>
        <div className="offer-items-grid grid grid-cols-1 xl:grid-cols-2 gap-x-4 gap-y-10">
          {
            !loading && allOffers.length > 0 && (
              <Fragment>
                {
                  allOffers.map((offer, i) => {
                    return (
                      <div key={i} className="col-span-1">
                        <div className="offer-item">
                          <a href={offer['link']} className="offer-item-image-wrapper">
                            {
                              offer['image'].length > 0 && (
                                <img src={offer['image']}
                                     className="offer-item-image"
                                     loading="lazy"
                                     decoding="async"
                                     alt=""
                                />
                              )
                            }
                          </a>
                          {
                            offer['types'].length > 0 && (
                              <div className="offer-item-types-wrapper">
                                {
                                  offer['types'].map((type, j) => {
                                    return (
                                      <div key={j} className="offer-item-type">
                                        {type}
                                      </div>
                                    );
                                  })
                                }
                              </div>
                            )
                          }
                          {
                            offer['title'].length > 0 && (
                              <div className="offer-item-title">
                                {offer['title']}
                              </div>
                            )
                          }
                          {
                            offer['description'] && (
                              <div className="offer-item-description"
                                   dangerouslySetInnerHTML={{__html: offer['description']}}
                              />
                            )
                          }
                          {
                            offer['link'].length > 0 && (
                              <div className="offer-item-link-wrapper">
                                <a href={offer['link']} className="btn offer-item-link">
                                  View details
                                </a>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    );
                  })
                }
              </Fragment>
            )
          }
          {
            (loading || loadMoreLoading) && (
              <OffersSkeleton />
            )
          }
        </div>
        <div className="load-more-button-container">
          <button className="btn btn-outline-black btn-load-more" disabled={loading || loadMoreLoading || loadedAll} onClick={this.loadMoreOffers}>
            {!loadedAll ? 'Load More' : 'That\'s All'}
          </button>
        </div>
      </Fragment>
    );
  }
}

AppHotelOffers.propTypes = {
  featuredOfferId: PropTypes.string,
};

AppHotelOffers.defaultProps = {
  featuredOfferId: '',
};

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // Render results
    const hotelOffersWrapper = $('#hotel-offers-wrapper');
    if (hotelOffersWrapper.length) {
      const hotelOffersProps = {...hotelOffersWrapper[0].dataset};

      ReactDOM.render(<AppHotelOffers {...hotelOffersProps} />, hotelOffersWrapper[0]);
    }

    const offerTypesFilter = $('#offer-types-filter');
    if (offerTypesFilter.length) {
      offerTypesFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['type'] = selectedVal;
        } else {
          delete params['type'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_OFFERS_TYPE_FILTER_CHANGED, [selectedVal]);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelOffersPage.js